import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';
import {shareReplay} from 'rxjs/operators';
import {NotificationCenterComponent} from '@pageControls/notification-center/notification-center.component';

@Injectable({providedIn: 'root'})
export class NotificationCenterHelperService {
  private ncSubject = new Subject<NotificationCenterComponent>();
  public ncObservable = this.ncSubject.pipe(shareReplay(1));
  private ncReceiverSubject = new Subject<any>();
  public ncReceiverObservable = this.ncReceiverSubject.pipe(shareReplay(1));

  constructor() { }

  public initProcessHelper() {

  }
  public refreshNCReceiverSubject(component: any) {
    this.ncReceiverSubject.next(component);
  }

  public refreshNCSubject(component: NotificationCenterComponent) {
    this.ncSubject.next(component);
  }
}
